<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div >
  <div class="vx-row">
            

            
            <!--div class="vx-col w-full sm:w-1/2 lg:w-2/3 mb-base mx-auto">
                <vx-card>
                    <div class="  ">
                        <div class="flex" ><p class="text-xl">{{data_local.nom_domaine}}</p>
                    </div></div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap pl-20 pr-20">
                        <span>
                            <p class="text-grey">formation</p>
                            <p class="text-xl">{{data_local.nb_formation}}</p>
                        </span>
                        <span>
                            
                        </span>
                        <span>
                            <p class="text-grey">formateur</p>
                            <p class="text-xl">{{data_local.nb_formateur}}</p> 
                        </span>
                        <span>
                            <p class="text-grey">candidat</p>
                            <p class="text-xl">{{data_local.nb_participation}}</p> 
                        </span>
                        <span>
                            
                        </span>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="vx-row">
                        <div class="vx-col w-1/2 mb-3">
                            <small>Goal: $100000</small>
                            <vs-progress class="block mt-1" :percent="50" color="primary"></vs-progress>
                        </div>
                        <div class="vx-col w-1/2 mb-3">
                            <small>Users: 100K</small>
                            <vs-progress class="block mt-1" :percent="60" color="warning"></vs-progress>
                        </div>
                        <div class="vx-col w-1/2 mb-3">
                            <small>Retention: 90%</small>
                            <vs-progress class="block mt-1" :percent="70" color="danger"></vs-progress>
                        </div>
                        <div class="vx-col w-1/2 mb-3">
                            <small>Duration: 1yr</small>
                            <vs-progress class="block mt-1" :percent="90" color="success"></vs-progress>
                        </div>
                    </div>
                    <vs-divider></vs-divider>
                     

                </vx-card>
            </div-->
            <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base mx-auto">
                <vx-card>
                    <img :src="data_local.image" alt="content-img" class="responsive rounded-lg">
                    <div class="my-6">
                        <h5 class="mb-2">{{data_local.nom_domaine}}</h5>
                        
                    </div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap">
                        <span>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"><p class="text-xl">{{data_local.nb_formation}} </p></vs-col>
                            <p class="text-grey">formation</p>
                        </span>
                        <span>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"><p class="text-xl">{{data_local.nb_formateur}}</p></vs-col>
                            <p class="text-grey">formateur</p>
                        </span>
                        <span>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"><p class="text-xl">{{data_local.nb_participation}}</p></vs-col>
                            <p class="text-grey">participation</p>
                        </span>
                    </div>
                </vx-card>
            </div>
            
        </div>

                
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moduledomaine from '@/store/domaine/moduledomaine.js'

//import axios from "../../../../http/axios/index.js"
//import users from "../../../../fake-db/data/user-management/index.js"
export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formations_length:0,
      formateurs_length:0,
      i:0,
      data_local: JSON.parse(JSON.stringify(this.data[0])),
     
    }
  },
  computed: {
  
    validateForm() {
      return !this.errors.any()
    }
  },
  created() {
    // Register Module UserManagement Module
    /*if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
    let obj = {}
    obj.formateur = this.$route.params.userId
    obj.formation = this.$route.params.userId
    this.$store.dispatch("domaine/fetchFormationsFormateur",obj).catch(err => { console.error(err) })
    //this.$store.dispatch("domaine/fetchFormateurs",this.$route.params.userId).catch(err => { console.error(err) })
*/
    },
  methods: {
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
   confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm Delete`,
        text: `You are about to delete "${this.data_local.nom}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      })
      
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.$router.push({name:'app-user-list'});
      //this.showDeleteSuccess()
       
      /* UnComment below lines for enabling true flow if deleting user */
       this.$store.dispatch("formation/removeRecord", this.data_local.id)
         .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
         .catch(err => { console.error(err)       })
         
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    } 
    
  },
}
</script>
<style lang="scss">

@import "@/assets/scss/vuexy/_variables.scss";

#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
      // padding-right: 2rem;
      // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
</style>
